import { PatientSexEnum, WeightMeasureEnum } from "requests";
import { SEX_TO_TITLE } from "../../../../../duck";

export const SEX_OPTIONS = [
  {
    value: PatientSexEnum.Female,
    label: SEX_TO_TITLE[PatientSexEnum.Female]
  },
  {
    value: PatientSexEnum.Male,
    label: SEX_TO_TITLE[PatientSexEnum.Male]
  },
  {
    value: PatientSexEnum.SpayedFemale,
    label: SEX_TO_TITLE[PatientSexEnum.SpayedFemale]
  },
  {
    value: PatientSexEnum.NeuteredMale,
    label: SEX_TO_TITLE[PatientSexEnum.NeuteredMale]
  }
];

export const WEIGHT_MEASURE_OPTIONS = [
  { value: WeightMeasureEnum.Kg, label: "kg" },
  { value: WeightMeasureEnum.Lbs, label: "lbs" },
  { value: WeightMeasureEnum.G, label: "g" }
];
